// extracted by mini-css-extract-plugin
export default {"input":"DatePickerFigo_input__0M4xu","icon":"DatePickerFigo_icon__wMox+"};